import React from 'react'
import ESW_CLASSNAMES from '../esw/classnames'
import { graphql } from 'gatsby'
import CriteoProduct from '../criteo/product'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AddToCart from '../components/add-to-cart'
import ImageAndThumbnails from '../components/image-and-thumbnails'
import Breadcrumbs from '../components/breadcrumbs'
import Price from '../components/price'
import PriceStriked from '../components/price-striked'
import PercentageOff from '../components/percentage-off'
import ProductCard from '../components/product-card'
import useGetPrice from '../hooks/useGetPrice'
import useGetAllProduct from '../hooks/useGetAllProduct'
import lockiconblack from '../images/svgs/lock-icon-black.svg'
import soundcloudgray from '../images/svgs/soundcloud-gray.svg'
import youtubegray from '../images/svgs/youtube-icon-gray.svg'
import BrowseCategories from "../components/browse-categories"

export const query = graphql`
    query ProductPageQuery($id: String) {
        product(id: {eq: $id}){
            id
            productId
            product_name
            short_description
            description
            sku
            slug
            badge            
            cdnLinkMac
            cdnLinkWindows
            releasedDate
            rawHTMLContent
            shop_categories {
                name
                slug
            }
            childrenFile {
                childImageSharp {
                    gatsbyImageData
                }
            }
            thumbnails: childrenFile {
                childImageSharp {
                    gatsbyImageData(width: 96, height: 64)
                }
            }
            includes {
                slug
                shop_categories {
                    slug
                }
                product_name
            }
            requires {
                product_name
                shop_categories {
                    slug
                }
                slug
            }
            works_with {
                id
                image
                name
                path
            }
        }
    }
`

export function Head(props) {
    const { data: { product } } = props
    const { product_name } = product
    return (
        <>
            <title>{product_name}</title>
            <CriteoProduct product={product} />
        </>
    )
}

export default function Product(props) {
    const { data, pageContext } = props
    const { crossSellSkus } = pageContext
    const { product } = data

    const {
        badge,
        product_name,
        shop_categories,
        description,
        short_description,
        prices,
        rawHTMLContent,
    } = product

    const { price } = useGetPrice(product)
    const allProduct = useGetAllProduct()
    const category = shop_categories[0]?.name

    return (
        <>
            <Container fluid className='bg-light' style={{paddingBottom: 38}}>
                <Container>
                    <Breadcrumbs product={product} />
                    <Row className='position-relative'>
                        <Col lg={6}>
                            <ImageAndThumbnails product={product} />
                            <div className='d-flex justify-content-between align-items-center'>
                                <div>
                                    <p className='ff-primary fw-bold mb-1' style={{ fontSize: 32 }}>{product_name}</p>
                                    <p className='text-uppercase text-secondary mb-4'>{category}</p>
                                </div>
                                <AddToCart
                                    product={product}
                                    className='text-primary fw-bold flex-center border border-primary border-2 py-2'
                                    style={{ borderRadius: 6, width: 180 }}
                                >
                                    BUY NOW
                                </AddToCart>
                            </div>
                            <div
                                style={{ fontSize: 14 }}
                                className='mb-4'
                                dangerouslySetInnerHTML={{ __html: description }}
                            />
                            <div id='sample' className='bg-white shadow py-3 px-4 mb-5'>
                                <p className='d-flex align-items-center gap-2' style={{ color: '#6c757d' }}>
                                    
                                    {category==='Presets' 
                                        ? 
                                            <span>
                                                <img src={youtubegray} alt='' height={24} width={24} />&nbsp;Watch video
                                            </span>
                                        :
                                            <span>
                                                <img src={soundcloudgray} alt='' height={24} width={24} />&nbsp;Listen to audio sample
                                            </span>
                                    }
                                </p>
                                <div
                                    style={{ fontSize: 14 }}
                                    dangerouslySetInnerHTML={{ __html: rawHTMLContent }}
                                />
                            </div>
                        </Col>
                        <Col className='mb-5'>
                            <div className='sticky-top bg-white p-5 shadow' style={{ borderRadius: 16, top: 126, zIndex: 1019 }}>
                                <h1 className='text-uppercase mb-1' style={{ fontSize: 40 }}>
                                    {product_name}
                                </h1>
                                <p className='text-uppercase text-secondary mb-4'>
                                    {category}
                                </p>
                                <div
                                    style={{ fontSize: 14 }}
                                    className='mb-3 w-md-75'
                                    dangerouslySetInnerHTML={{ __html: short_description }}
                                />
                                {price?.promotion_price &&
                                    <p className='mb-0 mt-4 d-flex gap-2 align-items-center'>
                                        <PriceStriked
                                            product={product}
                                            style={{ fontSize: 18 }}
                                            eswPriceStrikedClassname={ESW_CLASSNAMES.PAGE_PRICE}
                                        />
                                        <span className='bg-primary py-0 px-2' style={{ fontSize: 16, fontWeight: 800 }}>
                                            -<PercentageOff price={price} />%
                                        </span>
                                        <span className='text-uppercase text-white bg-black py-0 px-2' style={{ fontWeight: 600 }}>
                                            {price.promotion?.name}
                                        </span>
                                    </p>
                                }
                                <Price
                                    product={product}
                                    className='d-inline-block mb-4'
                                    style={{ fontSize: 32, fontWeight: 800 }}
                                    eswPriceClassName={ESW_CLASSNAMES.PAGE_PRICE}
                                />
                                <a
                                    href="#sample"
                                    className='text-dark fw-bold border border-dark border-2 flex-center w-100 py-2 mb-3'
                                    style={{ borderRadius: 6 }}
                                >
                                    {category==='Presets' ? 'WATCH VIDEO':'LISTEN TO AUDIO SAMPLE'}
                                </a>
                                <AddToCart
                                    product={product}
                                    className='text-primary fw-bold flex-center gap-2 border border-primary border-2 py-2 w-100'
                                    style={{ borderRadius: 6 }}
                                >
                                    BUY NOW
                                </AddToCart>
                                <p
                                    style={{ fontSize: 14 }}
                                    className='flex-center gap-1 mt-4 mb-0'
                                >
                                    <img src={lockiconblack} alt='' />
                                    Secure Checkout by ESW
                                </p>
                            </div>
                        </Col>
                    </Row>
                    <p className='ff-primary fw-bold mt-5' style={{ fontSize: 32 }}>
                        Others were interested in:                    
                    </p>
                    <Row className='pb-5'>
                        {crossSellSkus.map(sku => {
                            const product = allProduct.find(({ node }) => node.sku === sku)
                            return <ProductCard product={product.node} />
                        })}
                    </Row>
                </Container>
            </Container>
            <BrowseCategories />
        </>
    )
}
